import PostComponent from './Gpost2';
import SuitePost from './SuitePost';
import SliderPost from './postTest';
import MobileDisplayPost from './DisplayPostMobile';
import DesktopDisplayPost from './DisplayPostDesktop';
export { MobileDisplayPost, DesktopDisplayPost, SliderPost, SuitePost };
export default PostComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/post/index.ts
// module id = 944
// module chunks = 0 1 2 3 4 5 6 7